import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectLanguageIcon } from "../../../balancingSelectors/selectBalancingLanguage";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopInfo, selectCoopInfoView, selectCoopLevelFromXp, selectCoopRole, } from "../../../selectors/selectCoopInfo";
import { selectModalTabId } from "../../../selectors/selectModalTabId";
import { selectPlayerLevel } from "../../../selectors/selectPlayerLevelInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonNormalSmall } from "../../generic/common/ButtonNormalSmall";
import { ButtonPrimaryMedium } from "../../generic/common/ButtonPrimaryMedium";
import { ButtonSmallDelete } from "../../generic/common/ButtonSmallDelete";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
import { actionCoopInfoJoinCoop, actionCoopMenuSetFirstTab, actionCoopMenuTabGoTo, } from "../actionCoop";
import { IdCoopCategory } from "../IdCoopCategory";
import { CoopInfoNameDescription } from "./CoopInfoNameDescription";
import { CoopInfoProfile } from "./CoopInfoProfile";
import { CoopInfoStat } from "./CoopInfoStat";
import { IdCoopRole } from "./IdCoopRole";
var CoopInfoDOM = function (_a) {
    var coop = _a.coop, tabId = _a.tabId, onJoinCoopClick = _a.onJoinCoopClick, onLeaveCoopClick = _a.onLeaveCoopClick, playerCoop = _a.playerCoop, playerLevel = _a.playerLevel, role = _a.role, onEditCoopClick = _a.onEditCoopClick;
    if (!coop) {
        return React.createElement(React.Fragment, null);
    }
    var creationTime = coop.creationTime, name = coop.name, description = coop.description, xp = coop.xp, language = coop.language, minLevel = coop.minLevel, memberCount = coop.memberCount, memberLimit = coop.memberLimit, id = coop.id;
    var languageIcon = selectLanguageIcon(language);
    var onJoinCoopFn = playerCoop ? onLeaveCoopClick : function () { return onJoinCoopClick(id); };
    var isLevelNotEnough = (minLevel || 1) > playerLevel;
    var isFull = (memberCount || 0) === (memberLimit || 1);
    var isPlayerMember = playerCoop && id && playerCoop.id.equals(id);
    var editCoopBtn = isPlayerMember && (role === IdCoopRole.Leader || role === IdCoopRole.Deputy) ? (React.createElement("div", { className: "edit-btn__container" },
        React.createElement(ButtonNormalSmall, { onClick: onEditCoopClick },
            React.createElement(Icon, { icon: IdIcon.PlayerSettingsIcn, styleId: IdStyles.IconLarge })))) : (undefined);
    var joinLeaveBtn = tabId === IdCoopCategory.CoopInfoView || isPlayerMember ? (React.createElement(ButtonSmallDelete, { onClick: onLeaveCoopClick },
        React.createElement(Icon, { icon: IdIcon.LeaveAllianceIcn, styleId: IdStyles.IconLarge }))) : isLevelNotEnough || isFull ? (React.createElement(TooltipText, { id: isFull ? IdLoca.floatingText_coopFull : IdLoca.help_missingPlayerlevel_title, anchor: IdTooltipAnchor.Bottom },
        React.createElement(ButtonPrimaryMedium, { disabled: true },
            React.createElement(TextLoca, { id: IdLoca.join, className: IdStyles.TextButtonDefault })))) : (React.createElement(ButtonPrimaryMedium, { onClick: onJoinCoopFn },
        React.createElement(TextLoca, { id: IdLoca.join, className: IdStyles.TextButtonDefault })));
    var buttonsDOM = (React.createElement(React.Fragment, null,
        joinLeaveBtn,
        editCoopBtn));
    return (React.createElement("div", { className: IdStyles.CoopInfoContainer + " info-view_padding_small flex flex--spaced flex--around" },
        React.createElement(CoopInfoProfile, { level: selectCoopLevelFromXp(xp || Long.ZERO), creationTime: creationTime }),
        React.createElement(CoopInfoNameDescription, { name: name, description: description }),
        React.createElement("div", { className: "flex flex--stacked flex--spaced" },
            React.createElement(CoopInfoStat, { memberLimit: memberLimit, memberCount: memberCount, minLevel: minLevel, languageIcon: languageIcon, playerLevel: playerLevel, isMember: tabId === IdCoopCategory.CoopInfoView }),
            React.createElement("div", { className: "flex flex--guts info-view-buttons__container" }, buttonsDOM))));
};
var mapState = function (state) { return ({
    coop: selectCoopInfoView(state),
    playerCoop: selectCoopInfo(state),
    playerLevel: selectPlayerLevel(state),
    role: selectCoopRole(state),
    tabId: selectModalTabId(state, IdModal.Coop),
}); };
var mapDispatch = function (dispatch) { return ({
    onEditCoopClick: function () {
        dispatch(actionCoopMenuSetFirstTab(IdCoopCategory.CoopEdit));
        dispatch(actionCoopMenuTabGoTo(IdCoopCategory.CoopEdit));
    },
    onJoinCoopClick: function (coopId) { return dispatch(actionCoopInfoJoinCoop({ coopId: coopId })); },
    onLeaveCoopClick: function () { return dispatch(actionModalOpen(IdModal.CoopLeaveConfirm)); },
}); };
export var CoopInfo = connect(mapState, mapDispatch)(CoopInfoDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/CoopInfo.tsx
// module id = 916
// module chunks = 3